import { I18n } from '@calendly/i18n'
import { BrandLogo } from '@calendly/ui/components/brand-logo'
import { Button } from '@calendly/ui/components/button'
import { InlineBanner } from '@calendly/ui/components/inline-banner'
import { useDispatch } from 'react-redux'

import { redirectToAuthorizeUrl } from 'actions/omniauth'
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'
import { useTrackOnce } from 'hooks/analytics_events/useTrack'

import {
  emptyStateActionsCss,
  emptyStateButtonCss,
  emptyStateMessageCss,
  providerLogoCss,
} from './styles'

const STRIPE_AUTHORIZE_PATH = '/users/auth/stripe_oauth2'
const PAYPAL_PPCP_AUTHORIZE_PATH = '/users/auth/paypal_ppcp'

export const PaymentsEmptyState = () => {
  const dispatch = useDispatch()

  useTrackOnce(true, {
    name: TRACKING_EVENT_NAMES.CTA_SHOWN,
    entities: ['user', 'organization', 'attribution'],
    properties: {
      cta_destination: 'payment_processor_connect',
      cta_key: 'et_editor_crud_payment',
      cta_text: 'connect_stripe_or_paypal',
      cta_details: 'connect_a_payment_processor',
    },
  })

  const connectStripe = () => {
    dispatch(redirectToAuthorizeUrl(STRIPE_AUTHORIZE_PATH))
  }

  const connectPaypal = () => {
    dispatch(redirectToAuthorizeUrl(PAYPAL_PPCP_AUTHORIZE_PATH))
  }

  return (
    <div data-testid="payments-empty-state">
      <InlineBanner
        variant="info"
        hasIcon={false}
        isDismissible={false}
        title={I18n.t('publisher.event_type_editor_crud.payments.empty.title')}
        message={(
          <div className={emptyStateMessageCss}>
            <div>
              {I18n.t('publisher.event_type_editor_crud.payments.empty.description')}
            </div>
            <div className={emptyStateActionsCss}>
              <Button
                className={emptyStateButtonCss}
                data-testid="payments-connect-stripe"
                decoration="secondary-outline"
                size="small"
                onClick={connectStripe}
              >
                <BrandLogo className={providerLogoCss} name="stripe" />
                {I18n.t('publisher.event_type_editor_crud.payments.empty.connect_stripe')}
              </Button>
              <Button
                className={emptyStateButtonCss}
                data-testid="payments-connect-paypal"
                decoration="secondary-outline"
                size="small"
                onClick={connectPaypal}
              >
                <BrandLogo className={providerLogoCss} name="pay-pal" />
                {I18n.t('publisher.event_type_editor_crud.payments.empty.connect_paypal')}
              </Button>
            </div>
          </div>
        )}
      />
    </div>
  )
}
